import React from 'react';

import { ItemReorderEventDetail } from '@ionic/core';
import {
  IonItem,
  IonItemOptions,
  IonItemSliding,
  IonLabel,
  IonReorder,
  IonReorderGroup,
} from '@ionic/react';

export interface ReorderListConfig {
  data?: any[];
  onReorder?: (value: any[]) => void;
  secondaryActions?: (opt: any) => JSX.Element | null;
}

const ReorderList: React.FC<ReorderListConfig> = ({
  data,
  onReorder,
  secondaryActions,
}) => {
  const handleReorder = (event: CustomEvent<ItemReorderEventDetail>) => {
    onReorder?.(event.detail.complete(data));
  };

  if (!data?.length) {
    return (
      <IonItem>
        <IonLabel>No results</IonLabel>
      </IonItem>
    );
  }

  return (
    <IonReorderGroup disabled={false} onIonItemReorder={handleReorder}>
      {data.map(opt => {
        const { id, name } = opt;
        return (
          <IonItemSliding key={id}>
            <IonItem>
              <IonLabel>{name}</IonLabel>
              <IonReorder slot={'end'} />
            </IonItem>
            {secondaryActions && (
              <IonItemOptions side={'end'}>
                {secondaryActions(opt)}
              </IonItemOptions>
            )}
          </IonItemSliding>
        );
      })}
    </IonReorderGroup>
  );
};

export default ReorderList;
